<div class="ProfileSummarySection">
    <h1>{{title}}</h1>
    <p class="centeredText">{{firstSectionText}}</p>
    <p class="centeredText"> {{secondSectionText}}</p>
    <a *ngIf="linkToWebsite" href="{{linkToWebsite}}" target="_blank"><button class="LinkButton" type="button">Visit Website</button></a>
    <a *ngIf="linkToCode" href="{{linkToCode}}" target="_blank"><button class="LinkButton" type="button">See Code</button></a>
    <br/>
    <br/>
</div>
